import React from 'react';
import { Badge, Button, Tooltip } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

export default function MailboxHeaderButton({ visible, inboxUnread }) {
  const location = useLocation();
  const navigate = useNavigate();
  if (!visible) return null;
  const active = location.pathname === '/mail' || location.pathname.startsWith('/mail/');
  return <Tooltip title="Mail" placement="bottom">
    <Badge dot={Number(inboxUnread) > 0} color="#e11d2e" offset={[-2, 2]}>
      <Button className={`app-header-icon-button ${active ? 'is-active' : ''}`} type="text" aria-label="Open mailbox" aria-current={active ? 'page' : undefined} icon={<MailOutlined />} onClick={() => navigate('/mail')} />
    </Badge>
  </Tooltip>;
}
